import { JurisdictionsEnum } from '@libs/backend-common';
import { ThemeMode } from '@libs/types';
export const STORAGE_THEME_KEY = 'theme';
export const getPreselectedTheme = (jurisdictionId) => {
    if (jurisdictionId === JurisdictionsEnum.UA) {
        if (localStorage.getItem(STORAGE_THEME_KEY)) {
            return localStorage.getItem(STORAGE_THEME_KEY);
        }
        else {
            return ThemeMode.dark;
        }
    }
    else {
        return ThemeMode.light;
    }
};
//# sourceMappingURL=getPreseletedTheme.js.map